import { Injectable } from '@angular/core';
import { HierarchyFilterType } from '@app/features/hierarchy/models/hierarchy.constants';
import { NodeDto } from '@app/features/hierarchy/models/hierarchy.model';
import { EntitySelectionModel } from '@components/data/data-table-new/entitySelectionModel';

export type HierarchySelectionFilterData = [string, string, string, HierarchyFilterType?, string?] | [] | null;
@Injectable()
export class UserListFilterData {
  accepted: boolean;
  overlayOpened: boolean;
  selection = new EntitySelectionModel<NodeDto>();
  activeValue = ''; // Active
  profileValue = ''; // Profile id
  hieValue = ''; // Hierarchy selected
  hierarchySelectionFilterData: HierarchySelectionFilterData;

  clearData() {
    this.selection.clear();
    this.activeValue = '';
    this.profileValue = '';
    this.hieValue = '';
    this.hierarchySelectionFilterData = null;
  }
}
